import { ICommand, IDefineCommand, IQuery, IQueryMediator } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IAppointmentLocationsOrganizersDatasource } from '../datasources/appointment_location_staff_datasource';
import { IAppointmentReasonTypeDatasource } from '../datasources/appointment_reason_type_datasource';
import { UpcomingAppointmentsQuery } from '../queries/upcoming_appointments_query';
import { IAppointmentsTabsConfiguration } from '../servants/appointments_tabs_configuration';
import { PrepareAppointmentCampaignServant } from '../servants/prepare_appointment_campaign_request_servant';
import { IAppointment, IAppointmentCancellationForm, IAppointmentRequest } from '../types/appointment_interfaces';
import { IOrganizer } from '../types/appt_interfaces';
import { TAppointmentLocationsOrganizersUsersource } from '../usersources/appointment_location_staff_usersource';
import { TAppointmentReasonUsersource } from '../usersources/appointment_reason_usersource';

angular
  .module('capability-ng-appointments')
  .factory(
    'prepareAppointmentCampaignRequestCommand',
    (
      defineCommand: IDefineCommand,
      QueryMediator: IQueryMediator,
      $state: angular.ui.IStateService,
      ngUpcomingAppointmentsQuery: UpcomingAppointmentsQuery,
      ngAppointmentsTabsConfiguration: IAppointmentsTabsConfiguration,
      ngAppointmentReasonTypeDatasource: IAppointmentReasonTypeDatasource,
      ngAppointmentLocationsOrganizersDatasource: IAppointmentLocationsOrganizersDatasource,
      ngAppointmentLocationsOrganizersUsersource: TAppointmentLocationsOrganizersUsersource,
      ngAppointmentReasonUsersource: TAppointmentReasonUsersource,
      ngPrepareAppointmentCampaignServant: PrepareAppointmentCampaignServant,
      appointmentCampaignConstant: any
    ): ICommand => {
      return defineCommand(
        'prepareAppointmentCampaignRequestCommand',
        (deferred: ng.IDeferred<IQuery[]>, appointmentCampaignRequest: IAppointmentRequest): void => {
          const { appointment_type_instructions, appointment_types } =
            ngPrepareAppointmentCampaignServant.prepareAppointmentCampaignConfigData(appointmentCampaignRequest);
          const location_organizers_data =
            ngPrepareAppointmentCampaignServant.prepareAppointmentLocationOrganizersData(appointmentCampaignRequest);
          ngAppointmentReasonTypeDatasource
            .includeModel({
              appointment_type_instructions
            })
            .write(appointment_types);
          ngAppointmentLocationsOrganizersDatasource.write(location_organizers_data);

          QueryMediator.runQueries(ngAppointmentReasonTypeDatasource, ngAppointmentLocationsOrganizersDatasource);
          ngPrepareAppointmentCampaignServant.prepareAppointmentWorkflowStepsforCampaignRequest();
          deferred.resolve();
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/commands/prepare_appointment_campaign_request.ts